import { CountFilterBaseParams } from './CountFilterBaseParams';

/**
 * Holds count for a single filter
 * along current params the count is based on.
 */
export class CountFilterBaseDataItem {

    /** Waiting for request to be sent. */
    public static readonly STATE_WAITING = 1;

    /** API Request sent, waiting for response. */
    public static readonly STATE_REQUEST_SENT = 2;

    /** A valid count can be shown in UI. End state. */
    public static readonly STATE_READY = 3;

    public readonly filter_id: number;
    public readonly nix_option_id: number;
    public readonly source_id: number;
    public readonly use_number_source: boolean;
    public readonly timestamp: number;
    public state : number;
    public count: number;

    // ================================================================
    // === Create
    // ================================================================

    public static createNew(filterId: number, countParams: CountFilterBaseParams) : CountFilterBaseDataItem {
        return new CountFilterBaseDataItem(filterId, countParams, undefined);
    }

    public static createClone(original: CountFilterBaseDataItem) {
        return new CountFilterBaseDataItem(undefined, undefined, original);
    }

    private constructor(filterId: number|undefined, countParams: CountFilterBaseParams|undefined, original: CountFilterBaseDataItem|undefined) {

        if (filterId !== undefined && countParams !== undefined) {
            this.filter_id = filterId;
            this.nix_option_id = countParams.nix_option_id;
            this.source_id = countParams.source_id;
            this.use_number_source = countParams.use_number_source;
            this.timestamp = Date.now();
            this.state = CountFilterBaseDataItem.STATE_WAITING;
            this.count = 0;

        } else if (original !== undefined) {
            this.filter_id = original.filter_id;
            this.nix_option_id = original.nix_option_id;
            this.source_id = original.source_id;
            this.use_number_source = original.use_number_source;
            this.timestamp = original.timestamp;
            this.state = original.state;
            this.count = original.count;

        } else {
            throw Error("Unexpected case");
        }
    }

    // ================================================================
    // === State change
    // ================================================================

    /**
     * Checks if params matches params of the item.
     * This is used to determine if the count returned by the api can be used.
     */
    isValidForParams = (countParams: CountFilterBaseParams) : boolean => {
        return (
            this.nix_option_id === countParams.nix_option_id
            && this.source_id === countParams.source_id
            && this.use_number_source === countParams.use_number_source
            && (Date.now() - this.timestamp) < 1000 * 60 * 60       // 1 hour
        );
    }

    setReady = (count: number) : void => {
        this.state = CountFilterBaseDataItem.STATE_READY;
        this.count = count;
    }
}